module.exports = __webpack_public_path__ + "img/nav-2.e9ce5e6.png";